var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 118,
    viewBox: "0 0 102 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10938 46.946C26.4769 49.3828 50.9909 47.9728 73.9999 38.8353C81.4277 35.8855 90.8162 31.0991 93.6131 23.0194C95.9897 16.1537 93.2486 10.7457 87.0139 7.49844C76.4772 2.01059 58.6908 0.0663934 47.2345 3.81174C43.2839 5.10327 41.0934 6.27715 40.5984 10.4847C39.9217 16.2365 39.6091 22.7271 41.4095 28.3282C45.6311 41.462 56.1415 49.9618 65.6679 58.9278C68.5973 61.6848 72.0895 63.5546 75.3271 65.8956C79.2679 68.7451 82.7378 72.2767 86.3871 75.481C90.8108 79.3652 98.538 85.4173 99.5118 91.7025C101.832 106.676 87.4944 110.214 75.8801 113.601C63.1191 117.323 50.5044 116.536 37.2804 115.961",
    stroke: "#3EAB36",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.6bc1c551893edb0139bb67622c9b79a9.svg";
export { ForwardRef as ReactComponent };